import { CustomerContactInformation, Selector } from 'types';

export const getCustomerContacts: Selector<CustomerContactInformation | null> = (state) =>
  state.customerContacts.customerContacts;

export const getCustomerContactsLoading: Selector<boolean> = (state) =>
  state.customerContacts.loading.includes('');
